/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Teary_Guppy_MendInputs */

const fr_kind_teary_guppy_mend = /** @type {(inputs: Kind_Teary_Guppy_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de remplissage des cours`)
};

/**

* @param {Kind_Teary_Guppy_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const kind_teary_guppy_mend = /** @type {((inputs?: Kind_Teary_Guppy_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Teary_Guppy_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_kind_teary_guppy_mend(inputs)
});